// Native <input type="date"> arbeitet mit yyyy-MM-dd, die API mit ISO-Datetime. Beide
// Testplan-Formulare (Anlegen und Detail) brauchen dieselbe Umrechnung — deshalb hier
// gemeinsam statt zweimal lokal.

/** ISO-Datetime (aus der API) -> Wert für <input type="date">; null -> leeres Feld. */
export function toDateInputValue(iso: string | null): string {
  if (!iso) return '';
  return iso.slice(0, 10);
}

/** <input type="date">-Wert -> ISO-Datetime für die API; leerer Wert -> null. */
export function toIsoOrNull(value: string): string | null {
  if (!value) return null;
  return new Date(value).toISOString();
}

/**
 * <input type="date">-Wert -> ISO-Datetime am ENDE des Tages (23:59:59.999 lokal); leer -> null.
 * #50: Ein Bis-Datum aus einem Date-Input meint den ganzen Tag. Ohne das läge `to_date` auf
 * Mitternacht, und eine Vertretung „bis 20.10." wäre ab 00:01 am 20.10. schon abgelaufen — ein
 * Ein-Tages-Fenster (from == to) wäre praktisch nie aktiv (activeSubstituteFor prüft to ≥ now).
 */
export function toIsoEndOfDayOrNull(value: string): string | null {
  if (!value) return null;
  const d = new Date(value);
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
}
